import React from 'react';
//translations
import { useTranslation } from 'react-i18next';

const OrderStepper = ({ activeStep }) => {
  const { t } = useTranslation(['cart']);
  const steps = ['cart', 'shipping', 'payment'];

  const setClassNameStepper = (index) => {

    if (index === steps.length - 1 && activeStep !== index) {
      return '';
    } else if (index === steps.length - 1 && activeStep === index) {
      return 'active-end';
    } else if (activeStep === index) {
      return 'active';
    } else {
      return 'grayArrow';
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <ul className="nav nav-tabs wizard">
          {steps?.map((step, index) => (
            <li key={index} className={setClassNameStepper(index)}>
              {t(step)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default OrderStepper;
